// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__1tQDL","select":"style_select__3GkAv","form":"style_form__3gnoi","loader":"style_loader__1d9KO"};